import sislogUserGlobals from "components/UserGlobals";
import template from "./numericContent.hbs";
import "./numericContent.scss";
import numbro from "numbro";

export class NumericContent extends HTMLElement {

  constructor() {
    super();
  }
  set data(v: NumericContentData) {
    let options = {} as any;
    options = {
      thousandSeparated: true,
    };
    if (this.hasAttribute("decimals")
      && this.getAttribute("decimals") != null
      && this.getAttribute("decimals") !== ""
      && this.getAttribute("decimals") !== "undefined") {
        options.mantissa = parseInt(this.getAttribute("decimals"), 10);
    }
    numbro.setLanguage(sislogUserGlobals.locale);
    let value = numbro(v.value).format(options);

    this.innerHTML = template({
      value,
      size: this.getAttribute("size"),
      level: v.level,
      iconFont: this.getAttribute("iconFont"),
      unit: v.unit ?? this.getAttribute("unit"),
    });
  }
}

export function initNumericContentWebComponent() {
  window.customElements.define("s6-tile-numeric-content", NumericContent);
}

export interface NumericContentData {
  value: number;
  level?: "error" | "warning" | "info" | "success";
  unit?: string;

}